module.exports = __webpack_public_path__ + "static/media/chevron.5be43d79.svg";